export const BOX_SHADOW = {
  small: '0px 2px 5px rgba(0, 0, 0, 0.05)',
  large: '0px 0px 5px rgba(0, 0, 0, 0.05), 0px 25px 35px rgba(0, 0, 0, 0.01)',
};

export const BOX_SHADOW_DARK = {
  small: '0px 2px 5px rgba(145, 158, 171, 0.05)',
  large: '0px 0px 5px rgba(145, 158, 171, 0.05), 0px 25px 35px rgba(145, 158, 171, 0.01)',
};
